module.exports = __webpack_public_path__ + "media/common/js/components/content-units/templates/innogy-introduction/i2-2-8dee719849f4d2364b948f209290405f.svg";